<template>
  <section class="p-0">
    <!-- <div class="not-found-404">404</div>
        <div class="not-found-title">{{_T('Sorry')}}, {{_T('the page you are looking for could not be found')}}</div>
        <a class="not-found-link" href="/">{{_T('Go to home page')}}</a> -->
    <div class="page-wrapper">
      <!-- error-400 start-->
      <div class="error-wrapper">
        <div class="container">
          <img class="img-fluid" src="/images/sad.png" alt="" />
          <div class="error-heading">
            <h2 class="headline font-info">400</h2>
          </div>
          <div class="col-md-8 offset-md-2">
            <p class="sub-content">
              {{ _T('Sorry') }},
              {{ _T('the page you are looking for could not be found') }}
            </p>
          </div>
          <div>
            <router-link class="btn btn-solid" :to="{ path: '/' }">{{
              _T('Go to home page')
            }}</router-link>
          </div>
        </div>
      </div>
      <!-- error-400 end-->
    </div>
  </section>
</template>
<script>
import * as utils from '@/utils/main_utils'
import { mapGetters } from 'vuex'

export default {
  beforeMount() {
    document.title = '404 Error'
    utils.process_warning('Error 404 happened')
  },
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>
<style lang="scss" scoped>
.error-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 197px);
  text-align: center;
  .error-heading {
    margin-top: $px130;
    .headline {
      font-size: $px285;
      font-weight: 700;
      letter-spacing: $px1;
      margin-top: -$px130;
      line-height: 1;
      //   font-family: $font-work-sans, $font-serif;
    }
  }
  .sub-content {
    font-size: $px18;
    color: $font-color;
    letter-spacing: $px1;
    font-weight: normal;
    line-height: $px35;
    z-index: 3;
    position: relative;
    margin-top: $px30;
    margin-bottom: 0;
  }
  .btn {
    margin-top: $px40;
  }
}
@media (max-width: 1367px) {
  .error-wrapper {
    img {
      width: $px100;
    }
    .error-heading {
      margin-top: $px150;
      .headline {
        font-size: $px125;
        //   font-family: $font-work-sans, $font-serif;
      }
    }
  }
}
@media (max-width: 767px) {
  .error-wrapper {
    height: calc(100vh - 260px);
    .error-heading {
      .headline {
        font-size: $px100;
        //   font-family: $font-work-sans, $font-serif;
      }
    }
    .sub-content {
      font-size: $px16;
      line-height: $px22;
      margin-top: $px15;
    }
    .btn {
      margin-top: $px20;
    }
  }
}
</style>
